module.exports = __webpack_public_path__ + "media/images/cards-home-588bb6ffde296a52c932597ec2bd45bd.png";